module.exports = __webpack_public_path__ + "img/finance-dakuan.e450481c.svg";